import {
  AlertDialog as ReachAlertDialog,
  type AlertDialogProps,
} from "@reach/alert-dialog"

export { AlertDialogDescription, AlertDialogLabel } from "@reach/alert-dialog"

type Props<T extends HTMLElement = HTMLElement> = Omit<
  AlertDialogProps,
  "leastDestructiveRef"
> &
  React.HTMLAttributes<HTMLDivElement> & {
    leastDestructiveRef?: React.RefObject<T | null>
  }

export function AlertDialog<T extends HTMLElement = HTMLElement>({
  leastDestructiveRef,
  ...props
}: Props<T>) {
  return (
    <ReachAlertDialog
      leastDestructiveRef={leastDestructiveRef as React.RefObject<HTMLElement>}
      {...props}
    />
  )
}
